import { render, staticRenderFns } from "./Customer_Service_SideMenu.vue?vue&type=template&id=d31ef4da&scoped=true&"
import script from "./Customer_Service_SideMenu.vue?vue&type=script&lang=js&"
export * from "./Customer_Service_SideMenu.vue?vue&type=script&lang=js&"
import style0 from "./Customer_Service_SideMenu.vue?vue&type=style&index=0&id=d31ef4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31ef4da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
